import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import VehicleServices from '../services/VehicleServices';
import TogalButtonForStatus from './TogelButton/TogalButtonForStatus';
import useAsync from '../hooks/useAsync';
import Modal from 'react-modal';
import DeleteButton from './Button/DeleteButton';
import VehicleUpdate from './Update Model/UpdateVehicle';
import * as XLSX from 'xlsx';

Modal.setAppElement('#root');

function VehicleList() {
    const { data, error, isLoading, run } = useAsync(VehicleServices.getVehicle);
    const [activeIndex, setActiveIndex] = useState(null);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [selectedEdit, setSelectedEdit] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');

    const handleEditDetails = (vehicle) => {
        setSelectedEdit(vehicle);
        setIsEditModalOpen(true);
        toggleActionMenu(null);
    };

    const handleDelete = (vehicle) => {
        setSelectedEdit(vehicle);
        setIsDeleteModalOpen(true);
        toggleActionMenu(null);
    };

    const closeEditModal = () => {
        setIsEditModalOpen(false);
        setSelectedEdit(null);
    };

    const closeDeleteModal = () => {
        setIsDeleteModalOpen(false);
        setSelectedEdit(null);
    };

    const toggleActionMenu = (index) => {
        setActiveIndex(index === activeIndex ? null : index);
    };

    const formatDateTime = (isoString) => {
        const date = new Date(isoString);
        const day = String(date.getDate()).padStart(2, '0'); // Get day and pad with leading zero if needed
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Get month (0-11) and pad with leading zero
        const year = date.getFullYear(); // Get full year
        return `${day}-${month}-${year}`; // Format as DD-MM-YYYY
    };


    // Filtered data based on search query
    const filteredData = data?.data?.filter(vehicle =>
        vehicle?.name && vehicle.name.toLowerCase().includes(searchQuery.toLowerCase().trim()) ||
        vehicle?.brand?.type && vehicle.brand?.type.toLowerCase().includes(searchQuery.toLowerCase().trim()) ||
        vehicle?.brand?.name && vehicle.brand.name.toLowerCase().includes(searchQuery.toLowerCase().trim())
    );


    const generateExcel = () => {
        const filteredData = data?.data?.map(vehicle => ({
            type: vehicle?.brand?.type,
            brandname: vehicle?.brand?.name,
            name: vehicle?.name,
            image: process.env.REACT_APP_URL + vehicle?.brand?.image,
            date: formatDateTime(vehicle?.createdAt),
            status: vehicle?.status,
        }));

        const ws = XLSX.utils.json_to_sheet(filteredData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'vehicleData');
        XLSX.writeFile(wb, 'vehicle_data.xlsx');
    };

    return (
        <>
            <div className="right_col" role="main">
                <div className="d-md-flex  align-items-center justify-content-between my-4 page-header-breadcrumb">

                    <div className="my-auto">

                        <h5 className="page-title fs-21 mb-1">
                            Vehicle List  <span className="badge bg-orange">{filteredData?.length || 0}</span>
                        </h5>
                        <nav>

                            <ol className="breadcrumb mb-0">

                                <li className="breadcrumb-item">
                                    <a href="javascript:void(0);">Home</a>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">
                                    User List
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div className="d-flex my-xl-auto right-content align-items-center">

                        <div className="pe-1 mb-xl-0">

                            <div className="sub-title-box-right d-flex" style={{ gap: 20 }}>
                                <Link className="round-add-btn" to="/add-vehicle">
                                    <img src="img/plus.svg" alt="Add Vehicle List" />
                                </Link>
                                <button className="excel-btn" onClick={generateExcel}>
                                    <img src="img/excel.svg" alt="Download Excel" />
                                    Download
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container-box px-0 pt-2">
                    <div className="Tablesearch_design">
                        <div className="row">
                            <div className="col-sm-6">
                                <div className='d-flex align-items-center justify-content-between gap-2'>
                                    <div className=' w-100'>
                                        <input
                                            type="search"
                                            name="search"
                                            placeholder="Search by Name, Mobile and Email id"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            className='form-control'
                                        />
                                    </div>
                                    <div>
                                        <button className="search-btn">Search</button>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>

                    <div className="container-box-inner table-reponsive-tabe">
                        <table id="example" className="table table-striped" style={{ width: "100%" }}>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>VEHICLE TYPE</th>
                                    <th>IMAGE</th>
                                    <th>BRAND</th>
                                    <th>CAR</th>
                                    <th>DATE</th>
                                    <th>STATUS</th>
                                    <th>ACTION</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData?.map((vehicle, i) => (
                                    <tr key={i}>
                                        <td>{i + 1}</td>
                                        <td>{vehicle?.brand?.type}</td>
                                        <td>
                                            <div className="product-img">
                                                <img
                                                    src={process.env.REACT_APP_URL + vehicle?.brand?.image}
                                                    alt=""
                                                    style={{ height: '70px', width: '70px', objectFit: 'contain' }}
                                                />
                                            </div>
                                        </td>
                                        <td>{vehicle?.brand?.name}</td>
                                        <td>{vehicle?.name}</td>
                                        <td>{formatDateTime(vehicle?.createdAt)}</td>
                                        <td className="status-toggle">
                                            <TogalButtonForStatus data={vehicle} page="vehicle" onSuccess={() => run()} />
                                        </td>
                                        <td>
                                            <div className="action_toggle_outer">
                                                <button className="action_toggle" onClick={() => toggleActionMenu(i)}>
                                                    <i className="fa fa-ellipsis-v" />
                                                </button>
                                                {activeIndex === i && (
                                                    <div className="action_toggle_content product-edit show d-block">
                                                        <ul className="list-unstyled">
                                                            <li>
                                                                <button className="close_toggle" onClick={() => toggleActionMenu(null)}>
                                                                    <i className="fa fa-close" />
                                                                </button>
                                                            </li>
                                                            <li>
                                                                <button className="edit" onClick={() => handleEditDetails(vehicle)}>Edit</button>
                                                            </li>
                                                            <li>
                                                                <button className="reject" onClick={() => handleDelete(vehicle)}>Delete</button>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <Modal
                    isOpen={isEditModalOpen}
                    onRequestClose={closeEditModal}
                    contentLabel="User Details"
                    className="modal-content"
                    overlayClassName="modal-overlay"
                >
                    <VehicleUpdate vehicle={selectedEdit} closeModal={closeEditModal} onSuccess={run} />
                </Modal>
                <Modal
                    isOpen={isDeleteModalOpen}
                    onRequestClose={closeDeleteModal}
                    contentLabel="Delete Confirmation"
                    className="modal-content"
                    overlayClassName="modal-overlay"
                >
                    <DeleteButton data={selectedEdit} page="Vehicle" closeModal={closeDeleteModal} onSuccess={run} />
                </Modal>
            </div>
        </>
    );
}

export default VehicleList;
